
import { defineComponent, ref } from "vue";
import notificationsDisplayUnreadComponent from "@/modules/notifications/components/notificationsDisplayUnreadComponent.vue";
import notificationsDisplayAllComponent from "@/modules/notifications/components/notificationsDisplayAllComponent.vue";
export default defineComponent({
  name: "viewNotificationsIndex",
  components: {
    notificationsDisplayUnreadComponent,
    notificationsDisplayAllComponent,
  },
  setup(){
    const selectedComponent = ref('unread');
    return {
      selectedComponent,
    }
  }
});
